import { useState, useEffect, useRef } from "react";
import { Input } from "@/components/atoms/input";
import { Search, Loader2 } from "lucide-react";
import { useOrdersStore } from "./use-orders-store";

export default function OrderSearchFilter() {
  const { trackingIdFilter, setTrackingIdFilter, isSearching } =
    useOrdersStore();
  const [inputValue, setInputValue] = useState(trackingIdFilter);
  const isFirstLoad = useRef(true);

  useEffect(() => {
    setInputValue(trackingIdFilter);
  }, [trackingIdFilter]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      // Prevent triggering fetch on first render
      if (isFirstLoad.current) {
        isFirstLoad.current = false;
        return;
      }

      // Only call store if changed
      if (inputValue !== trackingIdFilter) {
        setTrackingIdFilter(inputValue.trim());
      }
    }, 800); // Increased debounce time for better UX

    return () => clearTimeout(timeout);
  }, [inputValue, trackingIdFilter, setTrackingIdFilter]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      // Trigger search immediately on Enter
      if (inputValue !== trackingIdFilter) {
        setTrackingIdFilter(inputValue.trim());
      }
    }
  };

  return (
    <div className="w-full relative">
      <Input
        type="text"
        placeholder="# Tracking ID"
        value={inputValue}
        onChange={handleInputChange}
        onKeyPress={handleKeyPress}
        icon={
          isSearching ? (
            <Loader2 className="w-4 h-4 animate-spin text-indigo-500" />
          ) : (
            <Search className="w-4 h-4" />
          )
        }
        className="bg-white w-full"
      />
      {isSearching && (
        <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
          <div className="text-xs text-indigo-600">Buscando...</div>
        </div>
      )}
    </div>
  );
}
